// services/base-captcha.service.ts
import { ICaptchaService, SliderCaptchaData, TrajectoryPoint } from '../interface/captcha.interface';

export abstract class BaseCaptchaService implements ICaptchaService {
  protected sliderCaptchaData: SliderCaptchaData | null = null;

  public setSliderCaptchaData(
    captchaId: string,
    sliderPosition: number,
    trajectory: TrajectoryPoint[],
    imageWidth: number = 400,
    imageHeight: number = 220
  ): void {
    this.sliderCaptchaData = {
      captchaId,
      sliderPosition,
      trajectory,
      imageWidth,
      imageHeight
    };
  }

  public resetCaptchaData(): void {
    this.sliderCaptchaData = null;
  }

  public getCaptchaData(): SliderCaptchaData | null {
    return this.sliderCaptchaData;
  }

  protected addCaptchaToFormData(formData: FormData): void {
    if (!this.sliderCaptchaData) {
      throw new Error('Captcha data not found');
    }

    formData.append('captcha_id', this.sliderCaptchaData.captchaId);
    formData.append('slider_position', this.sliderCaptchaData.sliderPosition.toString());
    formData.append('trajectory', JSON.stringify(this.sliderCaptchaData.trajectory));
    formData.append('image_width', this.sliderCaptchaData.imageWidth.toString());
    formData.append('image_height', this.sliderCaptchaData.imageHeight.toString());
  }

  // Проверка наличия данных капчи
  protected hasCaptchaData(): boolean {
    return this.sliderCaptchaData !== null;
  }
}
